"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayoutAccount = exports.updatePayoutAccounts = void 0;
var constants_1 = require("../constants");
function updatePayoutAccounts(payoutAccount) {
    var payoutAccounts = JSON.parse(sessionStorage.getItem(constants_1.PAYOUT_SESSION) || '[]');
    var payoutSessionAccountIndex = payoutAccounts.findIndex(function (account) { return account.accountId === payoutAccount.accountId; });
    var newPayoutAccounts;
    if (payoutSessionAccountIndex === -1) {
        newPayoutAccounts = __spreadArray(__spreadArray([], __read(payoutAccounts), false), [payoutAccount], false);
    }
    else {
        newPayoutAccounts = __spreadArray(__spreadArray(__spreadArray([], __read(payoutAccounts.slice(0, payoutSessionAccountIndex)), false), [
            payoutAccount
        ], false), __read(payoutAccounts.slice(payoutSessionAccountIndex + 1)), false);
    }
    sessionStorage.setItem(constants_1.PAYOUT_SESSION, JSON.stringify(newPayoutAccounts));
}
exports.updatePayoutAccounts = updatePayoutAccounts;
function getPayoutAccount(accountId) {
    var payoutAccounts = JSON.parse(sessionStorage.getItem(constants_1.PAYOUT_SESSION) || '[]');
    return payoutAccounts.find(function (account) { return account.accountId === accountId; });
}
exports.getPayoutAccount = getPayoutAccount;
